import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from 'i18next-http-backend';
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector';
import { isObject, mergeWith } from 'lodash';
import { TranslationNS } from './i18n.types';
import validationEn from './localJson/validation-en.json';
import validationEs from './localJson/validation-es.json';

// TEMPORARY WHILE CONTENT POP IS SORTED
const mergeNamespace =
  (ns: string) =>
  (live: object, fallback: object, key?: string): object => {
    if (isObject(live)) {
      return mergeWith(live, fallback, mergeNamespace(ns));
    } else {
      if (key && !live && fallback) {
        console.warn('missing content: ', ns, key);
      }
      if (key && live && !fallback) {
        console.warn('missing fallback: ', ns, key);
      }

      return live || fallback;
    }
  };

const i18NextInstanceOptions = {
  // debug: true,
  partialBundledLanguages: true,
  resources: { 'en-US': validationEn, 'es-US': validationEs },
  lng: 'en-US',
  load: 'currentOnly',
  fallbackLng: 'en-US',
  ns: ['core'] as TranslationNS[],
  defaultNS: 'core' as TranslationNS,
  react: {
    transKeepBasicHtmlNodesFor: [
      'p',
      'ul',
      'ol',
      'li',
      'br',
      'strong',
      'em',
      'i',
      'b',
      'a',
      'h1',
      'h2',
      'h3',
      'h4',
      'h5'
    ]
  }
};

// this is a hack maybe. Preference would be to use the provider, but we aren't always in react land - without refactoring everything and even then it might not be right.
// We need the current instance to be known in places like useTrans and transformObject.
// default the current instance to ERC;
let currentI18nextInstance = null;

export const getI18nextInstance = () => {
  if(currentI18nextInstance){
    return currentI18nextInstance;
  }

  currentI18nextInstance = i18n.createInstance();
  currentI18nextInstance
    .use(Backend)
    .use(initReactI18next)
    .use(I18nextBrowserLanguageDetector)
    .init(i18NextInstanceOptions);
  return currentI18nextInstance;
};
